import { QuestionDayTripPlanI18nPreQuestions } from "./pre-questions/pre-questions";

export const QuestionPlanPreQuestionsRoot = () => {
	return <QuestionDayTripPlanI18nPreQuestions />;
};

QuestionPlanPreQuestionsRoot.displayName = "QuestionPlanPreQuestionsRoot";
